import i18n from "@/i18n";

const routes = {
  path: "/tournament",
  name: "Tournament",
  component: () =>
    import(/* webpackChunkName: "tournament" */ "@/views/tournament/Main"),
  children: [
    {
      path: "adminlist",
      alias: "",
      name: "AdminList",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/AdminList"
        ),
      prop: true,
      meta: {
        location: "/tournament/adminlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.admin_tournament"),
        step: [
          i18n.t("menu.tournament.tournament"),
          i18n.t("page.tournament.admin_tournament"),
        ],
        menu_num: 5,
        sub_menu_num: 51,
      },
    },
    {
      path: "adminview/:tournamentno",
      name: "AdminView",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/AdminView"
        ),
      prop: true,
      meta: {
        location: "/tournament/adminlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_view"),
        step: [
          i18n.t("menu.tournament.tournament"),
          i18n.t("page.tournament.admin_tournament"),
        ],
        menu_num: 5,
        sub_menu_num: 51,
      },
    },
    {
      path: "adminrank/:tournamentno",
      name: "AdminRank",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/AdminRank"
        ),
      prop: true,
      meta: {
        location: "/tournament/adminlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_rank"),
        step: [
          i18n.t("menu.tournament.tournament"),
          i18n.t("page.tournament.admin_tournament"),
        ],
        menu_num: 5,
        sub_menu_num: 51,
      },
    },
    {
      path: "shoplist",
      alias: "",
      name: "ShopList",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/ShopList"
        ),
      prop: true,
      meta: {
        location: "/tournament/shoplist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.shop_tournament"),
        step: [
          i18n.t("menu.tournament.tournament"),
          i18n.t("page.tournament.shop_tournament"),
        ],
        menu_num: 5,
        sub_menu_num: 52,
      },
    },
    {
      path: "shopwrite",
      name: "ShopWrite",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/ShopWrite"
        ),
      prop: true,
      meta: {
        location: "/tournament/shoplist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_write"),
        step: [
          i18n.t("menu.tournament.tournament"),
          i18n.t("page.tournament.shop_tournament"),
        ],
        menu_num: 5,
        sub_menu_num: 52,
      },
    },
    {
      path: "shopwrite/:tournamentno+",
      name: "ShopModify",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/ShopWrite"
        ),
      prop: true,
      meta: {
        location: "/tournament/shoplist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_edit"),
        step: [
          i18n.t("menu.tournament.tournament"),
          i18n.t("page.tournament.shop_tournament"),
        ],
        menu_num: 5,
        sub_menu_num: 52,
      },
    },
    {
      path: "shopview/:tournamentno",
      name: "ShopView",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/ShopView"
        ),
      prop: true,
      meta: {
        location: "/tournament/shoplist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_view"),
        step: [
          i18n.t("menu.tournament.tournament"),
          i18n.t("page.tournament.shop_tournament"),
        ],
        menu_num: 5,
        sub_menu_num: 52,
      },
    },
    {
      path: "shoprank/:tournamentno",
      name: "ShopRank",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/ShopRank"
        ),
      prop: true,
      meta: {
        location: "/tournament/shoplist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_rank"),
        step: [
          i18n.t("menu.tournament.tournament"),
          i18n.t("page.tournament.shop_tournament"),
        ],
        menu_num: 5,
        sub_menu_num: 52,
      },
    },
  ],
};

export default routes;
